import { HttpInterceptorFn, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, tap, throwError } from 'rxjs';
import { TokenService } from './token.service';

/** Routes served to people who are not logged in, and endpoints that never need a session. */
const PUBLIC_ROUTES = ['/sign/', '/case-status/', '/auth/', '/webchat-widget', '/webchat-center'];

function isPublicContext(currentUrl: string, requestUrl: string): boolean {
  const path = (currentUrl || '').split('?')[0].split('#')[0];
  return PUBLIC_ROUTES.some(r => path === r.replace(/\/$/, '') || path.startsWith(r))
      || (requestUrl || '').includes('/public/');
}

export const authInterceptor: HttpInterceptorFn = (req, next) => {

  const router = inject(Router);
  const tokenService = inject(TokenService);

  const isEventApi = req.url.includes('/lead/v1') || req.url.includes('/event/v1');
  const token = isEventApi ? null : tokenService.getAccessToken();

  const authReq = token
    ? req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      })
    : req;

  return next(authReq).pipe(

    tap(event => {
      if (event instanceof HttpResponse) {

        const newToken = event.headers.get('X-Refresh-Token');

        if (newToken) {
          tokenService.setTokens(newToken);
        }

      }
    }),

    catchError((error: HttpErrorResponse) => {

      // A 401 means "this session cannot do that" — it only means "log in again" when the user is
      // actually inside the app. On a public page (a customer signing a document, tracking a case)
      // there is no session to expire, so clearing tokens and redirecting would throw a stranger
      // onto a login screen — and sign out the agent who opened the link in the same browser.
      if (error.status === 401 && !isPublicContext(router.url, req.url)) {
        tokenService.clear();
        router.navigate(['/auth/login']);
      }

      return throwError(() => error);
    })
  );
};